export const numberWithCommas = (x:any) => {
    if (x) {
      const parts = x.toString().split(".");
  
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
      const decimalPart = parts[1] || "00"; // Add decimal part or default to "00" if not present
  
      if (parseFloat(parts[1]) === 0 || parts[1] === undefined) {
        return `${integerPart}`;
      }
  
      return `${integerPart}.${decimalPart}`;
    }
    return "";
  };